import { beRecipientApiReSend } from 'Api/beRecipientApiTS'
import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

export const sendConfirmationEmail = async (
  idRecipient: number,
  idConfirmationMessage: number,
): Promise<boolean> => {
  const idList: number = storeGet(STORE_KEY_ID_LIST)

  const result = await beRecipientApiReSend(idRecipient, idList, {
    MessageId: idConfirmationMessage,
  })

  return result
}
